export default __webpack_public_path__ + "assets/images/f8bff8d09a7762f726d408be01d97f8d.png";